// Checks the current pathName against a storeconf-configured denylist of url patterns.
// Returns false (block script) if pathName matches any regex in `not_allowed_urls`.
// Returns true (allow script) when the list is missing, empty, or no pattern matches.
export const isScriptAllowedForPath = (
	userData: Record<string, string> | undefined,
	pathName: string | undefined,
	notAllowedPathListKey: string
) => {
	const notAllowedPathRegex = userData?.[notAllowedPathListKey];
	if (notAllowedPathRegex && pathName) {
		try {
			const urlsJson = JSON.parse(notAllowedPathRegex);
			const isNotAllowedPath = urlsJson?.not_allowed_urls.find((url: string) =>
				new RegExp(url).test(pathName)
			);
			if (isNotAllowedPath) {
				return false;
			}
		} catch (e) {
			console.log(`url Mapping wrong structure, please refresh with proper values`, e);
		}
	}
	return true;
};
